import type { FocAiTourStepDef } from './focAiTourTypes';

export type FocAiTourApi = {
  openAiPanel: () => void;
  showReportsAi?: () => void;
};

let api: FocAiTourApi | null = null;

export function registerFocAiTourApi(next: FocAiTourApi): () => void {
  api = next;
  return () => {
    if (api === next) api = null;
  };
}

export function getFocAiTourApi(): FocAiTourApi | null {
  return api;
}

export function prepareFocAiTourStep(
  id: string,
  steps: readonly FocAiTourStepDef[]
): void {
  const step = steps.find((entry) => entry.id === id);
  const tour = step?.tour;
  if (!api) return;
  if (tour === 'reports-ai-generate' && api.showReportsAi) {
    api.showReportsAi();
    return;
  }
  api.openAiPanel();
}
